import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, unref as _unref, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-1b5f4b18"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "animate modal"
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { style: {"color":"white"} }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"color":"white"} }, "Tu diploma estará disponible en unos minutos desde la sección Mis Diplomas.", -1))
const _hoisted_6 = { class: "answer" }
const _hoisted_7 = { class: "answer" }
const _hoisted_8 = { key: 2 }
const _hoisted_9 = { style: {"color":"white"} }
const _hoisted_10 = { class: "answer" }
const _hoisted_11 = { class: "answer" }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = {
  key: 2,
  class: "container"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spacer" }, null, -1))
const _hoisted_15 = { class: "question-title" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spacer" }, null, -1))
const _hoisted_17 = ["onClick"]
const _hoisted_18 = { key: 0 }
const _hoisted_19 = ["onClick"]
const _hoisted_20 = { key: 0 }
const _hoisted_21 = ["onClick"]
const _hoisted_22 = { key: 0 }
const _hoisted_23 = ["onClick"]
const _hoisted_24 = { key: 0 }

import { onMounted, ref } from 'vue'
import EvaluationService from '@/services/EvaluationService'
import { useAuth } from '@/store/useAuth'
import { useRoute } from 'vue-router'
import router from '@/router'
import DefaultLayout from '@/layouts/DefaultLayout.vue'
import QuestionInterface from '@/interfaces/QuestionInterface'
import main from '@/data/main.js'


export default /*#__PURE__*/_defineComponent({
  __name: 'EvaluationView',
  setup(__props) {

const evaluationService = new EvaluationService()
const store = useAuth()
const loading = ref(true)
const route = useRoute()
const id = route.params.id
const questions = ref()
const evaluation = ref()
const sending = ref(false)
const result = ref()
onMounted(async () => {
    loading.value = true
    if (!store.token) {
        router.push({ name: 'home' })
        return
    }
    const tries = await evaluationService.getUserTries(store.token, id)
    evaluation.value = await evaluationService.getEvaluationInfo(id)
    if (evaluation.value.max_tries <= tries) {
        router.push({ name: 'home' })
        return
    }
    questions.value = await evaluationService.generateEvaluation(store.token, id)
    loading.value = false
})

const handleAnswer = (question:number, answer:number) => {
    questions.value.forEach((item:any) => {
        if(item.id == question) {
            item.selected = answer
        }
    })
}

const handleSend = async () => {
    sending.value = true
    if (!store.token) {
        router.push({ name: 'home' })
        return
    }
    const answers:Array<QuestionInterface> = []
    questions.value.forEach((element:any) => {
        const item:QuestionInterface = {
            id: element.id,
            evaluation_id: element.evaluation_id,
            answer: element.selected
        }
        answers.push(item)
    });
    const response = await evaluationService.checkEvaluationResult(store.token, id, questions.value.length, answers)
    result.value = response
}

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createBlock(DefaultLayout, null, {
    default: _withCtx(() => [
      (sending.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            (!result.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  _createVNode(_component_v_icon, {
                    name: "ri-loader-2-fill",
                    animation: "spin",
                    class: "icon"
                  })
                ]))
              : _createCommentVNode("", true),
            (result.value.status)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  _createElementVNode("h1", _hoisted_4, [
                    _createVNode(_component_v_icon, {
                      name: "hi-emoji-happy",
                      scale: "5",
                      fill: "#fff"
                    }),
                    _createTextVNode(" ¡Has superado la prueba!")
                  ]),
                  _hoisted_5,
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("h3", null, "Total preguntas: " + _toDisplayString(result.value.total_questions), 1)
                  ]),
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("h3", null, "Respuestas correctas: " + _toDisplayString(result.value.good_answers), 1)
                  ]),
                  _createVNode(_component_RouterLink, {
                    to: {name: 'my-diplomas'},
                    class: "button mb5"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Mis diplomas")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_RouterLink, {
                    to: {name: 'home'},
                    class: "button"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Volver a inicio")
                    ]),
                    _: 1
                  })
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _createElementVNode("h1", _hoisted_9, [
                    _createVNode(_component_v_icon, {
                      name: "ri-emotion-unhappy-line",
                      scale: "5",
                      fill: "#fff"
                    }),
                    _createTextVNode(" No has superado el test")
                  ]),
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("h3", null, "Total preguntas: " + _toDisplayString(result.value.total_questions), 1)
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("h3", null, "Respuestas correctas: " + _toDisplayString(result.value.good_answers), 1)
                  ]),
                  _createVNode(_component_RouterLink, {
                    to: {name: 'home'},
                    class: "button"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Aceptar")
                    ]),
                    _: 1
                  })
                ]))
          ]))
        : _createCommentVNode("", true),
      (loading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
            _createVNode(_component_v_icon, {
              name: "ri-loader-2-fill",
              animation: "spin",
              class: "icon"
            })
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_13, [
            _createElementVNode("h1", null, _toDisplayString(evaluation.value.name), 1),
            _hoisted_14,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(questions.value, (question, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: question.id,
                class: "question"
              }, [
                _createElementVNode("p", _hoisted_15, _toDisplayString(index+1) + ". " + _toDisplayString(question.text), 1),
                _hoisted_16,
                _createElementVNode("div", {
                  class: "answer",
                  onClick: ($event: any) => (handleAnswer(question.id, 1))
                }, [
                  _createTextVNode(" a) " + _toDisplayString(question.answer_1) + " ", 1),
                  (question.selected == 1)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_18, [
                        _createVNode(_component_v_icon, {
                          name: "bi-check-square-fill",
                          fill: _unref(main).SECONDARY_COLOR
                        }, null, 8, ["fill"])
                      ]))
                    : _createCommentVNode("", true)
                ], 8, _hoisted_17),
                _createElementVNode("div", {
                  class: "answer",
                  onClick: ($event: any) => (handleAnswer(question.id, 2))
                }, [
                  _createTextVNode(" b) " + _toDisplayString(question.answer_2) + " ", 1),
                  (question.selected == 2)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_20, [
                        _createVNode(_component_v_icon, {
                          name: "bi-check-square-fill",
                          fill: _unref(main).SECONDARY_COLOR
                        }, null, 8, ["fill"])
                      ]))
                    : _createCommentVNode("", true)
                ], 8, _hoisted_19),
                _createElementVNode("div", {
                  class: "answer",
                  onClick: ($event: any) => (handleAnswer(question.id, 3))
                }, [
                  _createTextVNode(" c) " + _toDisplayString(question.answer_3) + " ", 1),
                  (question.selected == 3)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_22, [
                        _createVNode(_component_v_icon, {
                          name: "bi-check-square-fill",
                          fill: _unref(main).SECONDARY_COLOR
                        }, null, 8, ["fill"])
                      ]))
                    : _createCommentVNode("", true)
                ], 8, _hoisted_21),
                _createElementVNode("div", {
                  class: "answer",
                  onClick: ($event: any) => (handleAnswer(question.id, 4))
                }, [
                  _createTextVNode(" d) " + _toDisplayString(question.answer_4) + " ", 1),
                  (question.selected == 4)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_24, [
                        _createVNode(_component_v_icon, {
                          name: "bi-check-square-fill",
                          fill: _unref(main).SECONDARY_COLOR
                        }, null, 8, ["fill"])
                      ]))
                    : _createCommentVNode("", true)
                ], 8, _hoisted_23)
              ]))
            }), 128)),
            _createElementVNode("button", {
              onClick: handleSend,
              style: {"color":"white"}
            }, "Entregar respuestas y finalizar evaluación.")
          ]))
    ]),
    _: 1
  }))
}
}

})